import React, { memo } from 'react';

import classnames from 'classnames';

import './index.scss';

function Highlight({
  children,
  keys,
  style,
  className,
}: {
  children: React.ReactNode;
  keys: string[];
  style?: React.CSSProperties;
  className?: string;
}) {
  const string = React.Children.toArray(children).join('');
  const reg = new RegExp(keys.join('|'), 'g');
  const token = string.replace(reg, '#@$&#');
  const elements = token.split('#').map((x, index) =>
    index % 2 === 0 ? (
      x
    ) : (
      <mark key={index} className={classnames('highlight', className)} style={style}>
        {x[0] === '@' ? x.slice(1) : x}
      </mark>
    ),
  );

  return <>{elements}</>;
}

export default memo(Highlight);
